/** @file Builds the TexturePages table: skeleton pages first, then the built-in white and font pages. */
import { invariant } from '@pose2d/std/invariant';
import type { SkeletonData } from '@pose2d/core/types';
import { BUILTIN_PAGES, type TexturePages } from './texturePages';

/**
 * Page order is `data.pages`, then white (1x1, linear), then the bitmap-font page (`font.w` × `font.h`, nearest).
 * An attachment's `page` therefore indexes `pages` directly and `white` equals the number of skeleton pages.
 */
export function createTexturePages(data: SkeletonData, font: { w: number; h: number }): TexturePages {
  invariant(
    Number.isInteger(font.w) && Number.isInteger(font.h) && font.w > 0 && font.h > 0,
    'createTexturePages: font page size must be positive integers',
  );
  const white = data.pages.length;
  return {
    pages: [
      ...data.pages,
      { id: BUILTIN_PAGES.white, w: 1, h: 1, filter: 'linear' },
      { id: BUILTIN_PAGES.font, w: font.w, h: font.h, filter: 'nearest' },
    ],
    white,
    font: white + 1,
  };
}
